import React, { useState, useEffect } from "react";
import Context from "../context";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import Notification from "./taskbars/notification";
import Search from "./taskbars/search";
import Start from "./taskbars/start";

function Taskbar() {
  const [state, set] = useState({ time: {} });
  const cont = React.useContext(Context);
  useEffect(() => {
    var int = setInterval(() => {
      var date = new Date();
      set({
        time: {
          second: date.getSeconds,
          hour: date.getHours(),
          minute: date.getMinutes(),
          date: date.getDate(),
          month: date.getMonth(),
          year: date.getFullYear()
        }
      });
    }, 1000);
    return () => clearInterval(int);
  }, [state.time.second]);
  const openStart = () => {
    if (cont.openSearch) {
      cont.set().setState({ openSearch: false });
    }
    if (cont.openNotification) {
      cont.set().setState({ openNotification: false });
    }
    cont.openStart
      ? cont.set().setState({ openStart: false })
      : cont.set().setState({ openStart: true });
  };
  const openSearch = () => {
    if (cont.openStart) {
      cont.set().setState({ openStart: false });
    }
    if (cont.openNotification) {
      cont.set().setState({ openNotification: false });
    }
    cont.openSearch
      ? cont.set().setState({ openSearch: false })
      : cont.set().setState({ openSearch: true });
  };
  const openNotification = () => {
    if (cont.openStart) {
      cont.set().setState({ openStart: false });
    }
    if (cont.openSearch) {
      cont.set().setState({ openSearch: false });
    }
    cont.openNotification
      ? cont.set().setState({ openNotification: false })
      : cont.set().setState({ openNotification: true });
  };
  return (
    <>
      <Context.Consumer>
        {(data) => {
          return (
            <>
              <Start open={data.openStart} />
              <Search open={data.openSearch} />
              <Notification open={data.openNotification} />
            </>
          );
        }}
      </Context.Consumer>
      <div className="fixed left-0 bottom-0 flex bg-black text-white w-full z-20 border-t border-gray-900">
        <ContextMenu
          className="bg-gray-900 text-white font-light text-xs tracking-widest"
          id="taskbar_start_context"
        >
          {[
            "App & Features",
            "Mobility Center",
            "Power Options",
            "System",
            "Device Manager",
            "Network Connections",
            "Disk Management",
            "Computer Management",
            "Window Powershell",
            "Shutdown"
          ].map((d, i) => (
            <MenuItem key={i} className="cursor-pointer p-3 hover:bg-gray-800">
              {d}
            </MenuItem>
          ))}
        </ContextMenu>
        <div className="w-1/2 flex justify-start">
          <ContextMenuTrigger id="taskbar_start_context">
            <div
              onClick={openStart}
              className="flex justify-center p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
            >
              <i className="fab fa-windows"></i>
            </div>
          </ContextMenuTrigger>
          <div
            onClick={openSearch}
            className="flex justify-center p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
          >
            <i className="fas fa-search"></i>
          </div>
          <Context.Consumer>
            {(data) => {
              return data.openApp.map((d, i) => (
                <div
                  key={i}
                  title={d}
                  className="flex border-b justify-center p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500 text-xs"
                >
                  {d[0]}
                  {d[1]}
                </div>
              ));
            }}
          </Context.Consumer>
        </div>
        <div className="w-1/2 flex justify-end">
          <div className="hidden sm:flex justify-center p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500">
            <i className="fas fa-wifi"></i>
          </div>
          <div className="hidden sm:flex justify-center p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500">
            <i className="fas fa-volume-up"></i>
          </div>
          <div className="flex justify-center p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500">
            <i className="fas fa-battery-full"></i>
          </div>
          <div
            className="flex justify-center p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500 font-light"
            style={{ fontSize: 10 }}
          >
            {state.time.hour}:{state.time.minute}
          </div>
          <div
            onClick={openNotification}
            className="flex justify-center p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
          >
            <i className="fas fa-comment-alt"></i>
          </div>
        </div>
      </div>
    </>
  );
}

export default Taskbar;
